"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicCounselForModernEnterprise() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="233025" id="temporary-power-solutions" className="dark bg-background text-foreground relative min-h-screen flex flex-col lg:flex-row overflow-hidden">
      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
        .animate-scroll-line {
          animation: scrollLine 2s cubic-bezier(0.77, 0, 0.175, 1) infinite;
        }
      `}</style>

      {}
      <div className="flex-1 flex flex-col justify-center px-8 py-24 lg:px-16 xl:px-24 z-10 relative">
        <div ref={textRef} className={`max-w-2xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-primary mb-8 leading-[1.1] uppercase">
            Immediate Site Power
          </h1>
          
          <p className="font-default text-lg md:text-xl text-foreground mb-12 leading-relaxed max-w-xl">
            Gridspan Installations Ltd provides high-capacity temporary distribution and groundwork for industrial sites. We ensure your infrastructure is energized safely, efficiently, and with technical precision.
          </p>

          <div ref={ctaRef} className={`transition-all duration-1000 delay-300 ease-out ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Button size="lg" className="h-14 px-8 text-base font-bold tracking-widest bg-primary text-primary-foreground hover:bg-primary/90 rounded-none" asChild>
              <Link to="#request-a-technical-quote">
                REQUEST SPEC SHEET
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="absolute bottom-8 left-8 lg:left-16 xl:left-24 flex flex-col items-center gap-4 opacity-60 hidden md:flex">
          <span className="text-[10px] uppercase tracking-[0.3em] font-mono text-primary rotate-180" style={{
          writingMode: 'vertical-rl'
        }}>
            System Active
          </span>
          <div className="w-[1px] h-16 bg-border relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-scroll-line" />
          </div>
        </div>
      </div>

      {}
      <div className="flex-1 relative min-h-[50vh] lg:min-h-screen w-full">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648950/img/temporary_distribution_unit_night.png)]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/40 to-transparent lg:hidden" />
        
        {}
        <div className="absolute bottom-12 right-12 p-6 bg-background/80 backdrop-blur-md border border-secondary/30 rounded-none hidden lg:block">
          <div className="font-mono text-xs text-primary mb-2 tracking-widest uppercase">Technical Spec</div>
          <div className="space-y-1">
            <p className="font-mono text-sm text-foreground">VOLTAGE: 400V / 230V</p>
            <p className="font-mono text-sm text-foreground">LOAD: UP TO 1250A</p>
            <p className="font-mono text-sm text-foreground">RATING: IP67 ENCLOSURE</p>
          </div>
        </div>
      </div>
    </section>;
}